import React from 'react';
import { fmtBRL, fmtPct, fmtDateBR, semaforoClass } from '../utils/clinicalUtils';
import './clinical.css';

/**
 * ClinicalWeekCard — semana completa: tabela dia-a-dia (SEGUNDA..SÁBADO,
 * espelhando a planilha original "Gerenciamento de Resultados") + resumo
 * (receita, conversão, meta, atingimento) e o selo de resultado.
 * As cores/valores agregados vêm PRONTOS do backend (RN-16, RN-24, RN-28,
 * RN-29) — aqui só formatamos e exibimos.
 */
function ClinicalWeekCard({ week }) {
  const status = week.achievement_status || week.conversion_status || null;
  const color = status ? status.color : null;
  const days = week.days || [];

  return (
    <div className={`clinical-week-card ${semaforoClass(color)}`}>
      <h3>Semana {week.week_number}</h3>

      <div className="clinical-week-body">
        <div className="clinical-week-days">
          {days.length === 0 ? (
            <p className="clinical-empty">Sem lançamentos nesta semana.</p>
          ) : (
            <table className="clinical-table">
              <thead>
                <tr>
                  <th>Data</th>
                  <th className="num">% de fech.</th>
                  <th className="num">Receita total dia</th>
                  <th className="num">Valor Orçamentos</th>
                  <th className="num">Valor orç. Fechados</th>
                  <th className="num">Qtd. profissionais</th>
                  <th className="num">Qtd. Orç. novos</th>
                  <th className="num">Qtd. Orç. fechados</th>
                </tr>
              </thead>
              <tbody>
                {days.map((d) => (
                  <tr key={d.record_date}>
                    <td>{d.weekday_label} <span style={{ color: 'var(--text-3)' }}>({fmtDateBR(d.record_date)})</span></td>
                    <td className="num">{fmtPct(d.value_conversion, 0)}</td>
                    <td className="num">{fmtBRL(d.revenue_amount)}</td>
                    <td className="num">{fmtBRL(d.budgets_amount)}</td>
                    <td className="num">{fmtBRL(d.closed_budgets_amount)}</td>
                    <td className="num">{d.dentists_count}</td>
                    <td className="num">{d.budgets_count}</td>
                    <td className="num">{d.closed_budgets_count}</td>
                  </tr>
                ))}
                <tr className="week-total-row">
                  <td>Total</td>
                  <td className="num">{fmtPct(week.value_conversion, 0)}</td>
                  <td className="num">{fmtBRL(week.revenue_amount)}</td>
                  <td className="num">{fmtBRL(week.budgets_amount)}</td>
                  <td className="num">{fmtBRL(week.closed_budgets_amount)}</td>
                  <td className="num">{Number(week.avg_dentists || 0).toFixed(1).replace('.', ',')}</td>
                  <td className="num">{week.budgets_count}</td>
                  <td className="num">{week.closed_budgets_count}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="clinical-week-summary">
          <div className="week-big-pct">{fmtPct(week.value_conversion, 0)}</div>
          <div className="week-big-caption">
            {(week.conversion_status && week.conversion_status.label) || '—'}
          </div>

          <div className="week-line" style={{ marginTop: 12 }}>
            <span>Meta</span>
            <span>{week.target_value !== null && week.target_value !== undefined ? fmtBRL(week.target_value) : '—'}</span>
          </div>
          <div className="week-line">
            <span>Atingimento</span>
            <span>{week.achievement !== null && week.achievement !== undefined ? fmtPct(week.achievement) : '—'}</span>
          </div>
          <div className="week-line" style={{ marginTop: 12 }}>
            <span>Ticket médio orçamentos</span>
            <span>{fmtBRL(week.avg_budget_ticket)}</span>
          </div>
          <div className="week-line">
            <span>Ticket médio orç. fechados</span>
            <span>{fmtBRL(week.avg_closed_budget_ticket)}</span>
          </div>

          {status && (
            <div className="week-status">
              <span className={`badge-${color}`}>{status.label}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ClinicalWeekCard;
